<template>
  <div class="position-detail-unselected">
    <div class="position-detail-unselected__vertical-center">
      <template v-if="activePosition.gemeente.app_asset">
        <template v-if="activePosition.gemeente.app_asset.splash_landscape_url">
          <img
            :src="activePosition.gemeente.app_asset.splash_landscape_url"
            alt=""
          />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    activeFeature() {
      return this.$store.state.ui.activeFeature;
    },
    activePosition() {
      return this.$store.state.ui.activePosition;
    }
  }
};
</script>

<style scoped lang="scss">
.position-detail-unselected {
  // anders regelen... absolute positioning
  width: calc(100% - 414px);
  position: absolute;
  right: 0;
  height: 100%;

  &__vertical-center {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
  }
}
</style>
